var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-wrap bg-white border border-mouse rounded-sm p-xxs w-full min-h-10"},_vm._l((_vm.value),function(talent){return _c('span',{key:talent.id,staticClass:"bg-gray rounded-sm py-xxxs px-xxs text-charcoal mx-xxs my-xxxs"},[_vm._v("\n        "+_vm._s(talent.name || talent.email)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }